import { render, staticRenderFns } from "./AnimScroll.vue?vue&type=template&id=15876c12&scoped=true&"
import script from "./AnimScroll.vue?vue&type=script&lang=js&"
export * from "./AnimScroll.vue?vue&type=script&lang=js&"
import style0 from "./AnimScroll.vue?vue&type=style&index=0&id=15876c12&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15876c12",
  null
  
)

export default component.exports